module.exports = __webpack_public_path__ + "fonts/eb3e0ac26fbf1f15b9dfc9d24b787188.svg";